import { render, staticRenderFns } from "./PropertyDocumentModal.vue?vue&type=template&id=2b4a321f"
import script from "./PropertyDocumentModal.vue?vue&type=script&lang=js"
export * from "./PropertyDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports